const countryData = [{'name': 'South Korea', 'code': 'KR', 'dial_code': '+82'}, {'name': 'United States', 'code': 'US', 'dial_code': '+1'}, {'name': 'Canada', 'code': 'CA', 'dial_code': '+1'}, {'name': 'United Kingdom', 'code': 'GB', 'dial_code': '+44'}, {'name': 'Germany', 'code': 'DE', 'dial_code': '+49'}, {'name': 'France', 'code': 'FR', 'dial_code': '+33'}, {'name': 'Italy', 'code': 'IT', 'dial_code': '+39'}, {'name': 'Spain', 'code': 'ES', 'dial_code': '+34'}, {'name': 'Netherlands', 'code': 'NL', 'dial_code': '+31'}, {'name': 'Thailand', 'code': 'TH', 'dial_code': '+66'}, {'name': 'Vietnam', 'code': 'VN', 'dial_code': '+84'}, {'name': 'Philippines', 'code': 'PH', 'dial_code': '+63'}, {'name': 'Singapore', 'code': 'SG', 'dial_code': '+65'}, {'name': 'Malaysia', 'code': 'MY', 'dial_code': '+60'}, {'name': 'Indonesia', 'code': 'ID', 'dial_code': '+62'}, {'name': 'Other', 'code': 'OT', 'dial_code': '+000'}];
const statesData = [
  {
    "name": "South Korea",
    "iso2": "KR",
    "dial_code": "+82",
    "states": [
        { "name": "Seoul", "state_code": "SEO" },
        { "name": "Busan", "state_code": "BUS" },
        { "name": "Incheon", "state_code": "INC" }
    ]
  },
  {
    "name": "United States",
    "iso2": "US",
    "dial_code": "+1",
    "states": [
        
    ]
  },
  {
    "name": "Canada",
    "iso2": "CA",
    "dial_code": "+1",
    "states": [
        
    ]
  },
  {
    "name": "United Kingdom",
    "iso2": "GB",
    "dial_code": "+44",
    "states": [
        
    ]
  },
  {
    "name": "Germany",
    "iso2": "DE",
    "dial_code": "+49",
    "states": [
        
    ]
  },
  {
    "name": "France",
    "iso2": "FR",
    "dial_code": "+33",
    "states": [
        
    ]
  },
  {
    "name": "Italy",
    "iso2": "IT",
    "dial_code": "+39",
    "states": [
        
    ]
  },
  {
    "name": "Spain",
    "iso2": "ES",
    "dial_code": "+34",
    "states": [
        
    ]
  },
  {
    "name": "Netherlands",
    "iso2": "NL",
    "dial_code": "+31",
    "states": [
        
    ]
  },
  {
    "name": "Thailand",
    "iso2": "TH",
    "dial_code": "+66",
    "states": [
        
    ]
  },
  {
    "name": "Vietnam",
    "iso2": "VN",
    "dial_code": "+84",
    "states": [
        
    ]
  },
  {
    "name": "Philippines",
    "iso2": "PH",
    "dial_code": "+63",
    "states": [
        
    ]
  },
  {
    "name": "Singapore",
    "iso2": "SG",
    "dial_code": "+65",
    "states": [
        
    ]
  },
  {
    "name": "Malaysia",
    "iso2": "MY",
    "dial_code": "+60",
    "states": [
        
    ]
  },
  {
    "name": "Indonesia",
    "iso2": "ID",
    "dial_code": "+62",
    "states": [
        
    ]
  },
  {
    "name": "Other",
    "iso2": "OT",
    "dial_code": "+000",
    "states": [
        
    ]
  }
];